import { render, staticRenderFns } from "./NpaCategory.vue?vue&type=template&id=c8210856"
import script from "./NpaCategory.vue?vue&type=script&lang=js"
export * from "./NpaCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports